/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Definitions_Ingested_Data_DescInputs */

const es_tyc_definitions_ingested_data_desc = /** @type {(inputs: Tyc_Definitions_Ingested_Data_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivos subidos directamente a Nexata o sincronizados desde Fuentes Conectadas y procesados por la plataforma.`)
};

const en_tyc_definitions_ingested_data_desc = /** @type {(inputs: Tyc_Definitions_Ingested_Data_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files uploaded directly to Nexata or synced from Connected Sources and processed by the platform.`)
};

/**
* | output |
* | --- |
* | "Files uploaded directly to Nexata or synced from Connected Sources and processed by the platform." |
*
* @param {Tyc_Definitions_Ingested_Data_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_definitions_ingested_data_desc = /** @type {((inputs?: Tyc_Definitions_Ingested_Data_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Definitions_Ingested_Data_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_definitions_ingested_data_desc(inputs)
	return en_tyc_definitions_ingested_data_desc(inputs)
});
export { tyc_definitions_ingested_data_desc as "tyc.definitions.ingested_data_desc" }